<template>
  <div class="page page-contact container is-fluid">
    <div class="container container-inner">
      <div class="columns is-gapless is-multiline">

        <!-- <div class="column content is-hidden-tablet" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true">
          <img src="../assets/image-07.jpg" class="img-responsive" />
        </div> -->

        <div class="column content content-main is-right" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="contact">
          <div class="title">
            {{ contact.title }}
          </div>
          <markdown v-if="contact.content" :source="contact.content" />
        </div>

        <!-- <div class="column content" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true">
          <img src="../assets/image-07.jpg" class="img-responsive is-hidden-mobile" />
          <div class="box color-gray-lighter-bg" v-if="false">
            <div class="text">
              For those in need of a Spanish speaking representative we have an associate available for you. Para aquellos que necesiten un representante que hable español tenemos un representante  disponible para asistirlo.
            </div>
          </div>
        </div>

        <div class="column content is-hidden-tablet" style="margin-bottom:0;" v-if="false">
          <div class="box color-gray-lighter-bg">
            <div class="subtitle" style="margin-bottom:0.8em;">
              Collection and Probation Services
            </div>
            <div class="text">
              We provide range of services. Click <a href="/services">here</a> for our list of services.
            </div>
          </div>
        </div> -->

      </div>

      <div class="columns is-gapless is-multiline">
        <div class="column content content-sub" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="contact1">
          <markdown v-if="contact1.content" :source="contact1.content" />
          <!-- <div class="subtitle">
            MARTINEZ OFFICE
          </div>
          <div class="text" style="margin-top:15px;">
            4210 Columbia Road Suite 6B Martinez, Georgia 30907<br />
            Call: 706-550-0411<br />
            Fax:  706-550-0416
          </div>
          <div class="text" style="margin-top:15px;">
            Samantha Gay<br />
            Email:  samgay.cms@comcast.net<br />
            Call: 706-550-0411 ext. 1
          </div>
          <div class="text" style="margin-top:15px;">
            Arlene Ormaza<br />
            Email:  arlene.ormaza.cms@comcast.net<br />
            Call: 706-550-0411 ext. 2
          </div>
          <div class="text" style="margin-top:15px;">
            Amanda Barrow<br />
            Email:  abarrow.coms@comcast.net<br />
            Call: 706-550-0411 ext 4
          </div> -->
        </div>
        <div class="column content content-sub" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="contact2">
          <markdown v-if="contact2.content" :source="contact2.content" />
          <!-- <div class="subtitle">
            THOMSON OFFICE
          </div>
          <div class="text" style="margin-top:15px;">
            647A Main Street Thomson, Georgia 30824<br />
            Call: 706-595-5657<br />
            Fax: 706-595-5688
          </div>
          <div class="text" style="margin-top:15px;">
            Amy Kitchens<br />
            Email:  akitchenscms@comcast.net
          </div>
          <div class="subtitle" style="margin-top:30px;">
            PRESIDENT/CEO
          </div>
          <div class="text" style="margin-top:15px;">
            Teresa McClellan<br />
            Email: t.mcclellan.cms@comcast.net<br />
            Call: 706-550-0411 ext. 3
          </div> -->
        </div>
      </div>

      <div class="columns is-gapless content" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="note">
        <div class="column">
          <div class="box color-gray-lighter-bg">
            <markdown v-if="note.content" :source="note.content" />
            <!-- <div class="text">
              For Spanish speaking clients please reach out to the following representative. Para clientes que hablen español favor de contactar al siguiente representante:
            </div>
            <div class="text">
              Arlene Ormaza
              Email:  arlene.ormaza.cms@comcast.net
              706-550-0411 ext. 2
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Markdown from 'vue-markdown'
import EventBus from '@/controllers/EventBus'

import Site from '@/apis/Site'

export default {
  name: 'page-contact',
  components: {
    Markdown
  },
  data () {
    return {
      isDesktop: true,
      contact: undefined,
      contact1: undefined,
      contact2: undefined,
      note: undefined
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.getContact()
    this.getContact1()
    this.getContact2()
    this.getNote()
  },
  methods: {
    async getContact () {
      try {
        let data
        // contact
        this.contact = undefined
        data = await Site.aboutNamed('contact')
        if (data && data[0]) {
          data = data[0]
          this.contact = data
        }
      } catch (error) {
        console.log('contact error', error)
      }
    },

    async getContact1 () {
      try {
        let data
        // contact 1
        this.contact1 = undefined
        data = await Site.aboutNamed('contact-section-1')
        if (data && data[0]) {
          data = data[0]
          this.contact1 = data
        }
      } catch (error) {
        console.log('contact error', error)
      }
    },

    async getContact2 () {
      try {
        let data
        // contact 2
        this.contact2 = undefined
        data = await Site.aboutNamed('contact-section-2')
        if (data && data[0]) {
          data = data[0]
          this.contact2 = data
        }
      } catch (error) {
        console.log('contact error', error)
      }
    },

    async getNote () {
      try {
        let data
        // note
        this.note = undefined
        data = await Site.aboutNamed('contact-note')
        if (data && data[0]) {
          data = data[0]
          this.note = data
        }
      } catch (error) {
        console.log('contact error', error)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";
@import "../styles/page.scss";

.page-contact {
  .content {
    // margin-top: 30px;
    // margin-bottom: 30px;
    // // padding: 30px;
    //
    &.content-main {
      padding-bottom: 15px;
    }

    &.content-sub {
      padding: 15px 30px;
      @media screen and (max-width: ($tablet - 1)) {
        padding: 15px 30px;
      }
    }

    ul.list {
      li {
        margin-top: 30px;
      }
    }

    a {
      // text-decoration: underline;
      // color: $color-primary-blue;
      font-size: 1.0em;
    }
  }
}

</style>



// WEBPACK FOOTER //
// contact.vue?9e4bb956